// extracted by mini-css-extract-plugin
module.exports = {"screenXs":"0","screenSm":"600","screenMd":"960","screenLg":"1280","screenXl":"1920"};